import "./home-hero.scss";

//Set vars
var hero = document.getElementById('js-home-hero');
var staticWord = document.getElementById('js-static-word');
var spacers = document.getElementsByClassName('js-slice-heading-spacer');
var fixedScroll = document.getElementById('js-scroll-fix');
var indicatorDots = document.getElementsByClassName('js-indicator');
var slices = document.getElementsByClassName('js-slice');
var activeSlice = document.getElementsByClassName('active-slice');

if (hero) {
  var activeIndex = hero.dataset.activeIndex;
  var heroActive = true;

  // Add fixed scroll on load
  function fixScroll() {
    if (window.scrollY == 0) {
      fixedScroll.classList.add('fixed-scroll');
    }
  }

  function unfixScroll() {
    heroActive = false;
    fixedScroll.classList.remove('fixed-scroll');
  }

  fixScroll();

  // Add padding based on width of the static word
  function staticWordResize() {
    for (var i = 0; i < spacers.length; i++) {
      var currentSpacer = spacers[i];
      var width = staticWord.offsetWidth;
      currentSpacer.style.width = width + "px";
    }
  }

  staticWordResize();

  window.addEventListener('resize', staticWordResize);


  //Indicator dots function
  for (var i = 0; i < indicatorDots.length; i++) {

    indicatorDots[i].addEventListener('click', function () {
      var thisIndicator = this;
      var thisSliceId = thisIndicator.dataset.slice;
      var thisSlice = document.getElementById(thisSliceId);
      var newActiveIndex = thisSlice.dataset.index;
      var currentlyActiveSlice = activeSlice[0];

      if (thisSlice != currentlyActiveSlice) {
        currentlyActiveSlice.classList.add('fade-up');
        activeIndex = newActiveIndex;

        setTimeout(function () {
          for (var i = 0; i < indicatorDots.length; i++) {
            indicatorDots[i].classList.remove('active-indicator');
            slices[i].classList.remove('active-slice');
            slices[i].classList.remove('fade-up');
          }

          thisSlice.classList.add('active-slice');
          thisIndicator.classList.add('active-indicator');
        }, 200);
      }
    });
  }

  // Next/Prev Function

  function changeSlice(current, direction) {
    var currentlyActiveSlice = activeSlice[0];

    if (direction == "up") {
      var nextSliceIndex = --current;
      var nextSlice = slices[nextSliceIndex];
      var nextIndicator = indicatorDots[nextSliceIndex];

      if (nextSliceIndex == (slices.length - 2)) {
        fixScroll();
      }

      // Check if at top of hero, if so, return.
      if (nextSliceIndex < 0) {
        return;
      }

      //Animate out current slice, and then timeout to transition the new one in.
      currentlyActiveSlice.classList.add('fade-up');

      setTimeout(function () {
        for (var i = 0; i < indicatorDots.length; i++) {
          indicatorDots[i].classList.remove('active-indicator');
          slices[i].classList.remove('active-slice');
          slices[i].classList.remove('fade-up');
        }

        nextSlice.classList.add('active-slice');
        nextIndicator.classList.add('active-indicator');
      }, 200);

    } else {
      // Assume down
      var nextSliceIndex = ++current;
      var nextSlice = slices[nextSliceIndex];
      var nextIndicator = indicatorDots[nextSliceIndex];

      // Check if at bottom of hero, if so, return.
      if (nextSliceIndex >= slices.length) {
        unfixScroll();
        return;
      }

      //Animate out current slice, and then timeout to transition the new one in.
      currentlyActiveSlice.classList.add('fade-up');

      setTimeout(function () {
        for (var i = 0; i < indicatorDots.length; i++) {
          indicatorDots[i].classList.remove('active-indicator');
          slices[i].classList.remove('active-slice');
          slices[i].classList.remove('fade-up');
        }

        nextSlice.classList.add('active-slice');
        nextIndicator.classList.add('active-indicator');
      }, 200);
    }
  }


  // Scroll listener for the hero
  var userHasScrolled = false;

  window.addEventListener('wheel', function (event) {
    if (window.scrollY > 0) {
      userHasScrolled = true
    }
    if (heroActive) {
      if (event.deltaY < 0) {
        var current = activeSlice[0].dataset.index;
        changeSlice(current, "up");
        heroActive = false;
        setTimeout(function () { userHasScrolled = true }, 1000);
      }
      else if (event.deltaY > 0) {
        var current = activeSlice[0].dataset.index;
        changeSlice(current, "down");
        heroActive = false;
        setTimeout(function () { userHasScrolled = true }, 1000);
      }
    } else if (window.scrollY == 0 && userHasScrolled) {
      heroActive = true;
      fixScroll();
      userHasScrolled = false;
    }
  });

  // Keys 
  document.onkeydown = checkKey;

  function checkKey(e) {
    e = e || window.event;
    if (e.keyCode == '38') {
      var current = activeSlice[0].dataset.index;
      if (window.scrollY == 0) {
        changeSlice(current, "up");
      }
      if (window.scrollY > 0) {
        userHasScrolled = true
      }
      if (window.scrollY == 0 && userHasScrolled) {
        heroActive = true;
        fixScroll();
        userHasScrolled = false;
      }
    }
    else if (e.keyCode == '40') {
      var current = activeSlice[0].dataset.index;
      if (window.scrollY == 0) {
        changeSlice(current, "down");
      }
      if (window.scrollY > 0) {
        userHasScrolled = true
      }
      if (window.scrollY == 0 && userHasScrolled) {
        heroActive = true;
        fixScroll();
        userHasScrolled = false;
      }
    }
  }

  // Touch Handlers
  var ts;
  document.addEventListener('touchstart', function (e) {
    ts = e.touches[0].clientY;
  });

  document.addEventListener('touchend', function (e) {
    var te = e.changedTouches[0].clientY;
    if (ts > te + 5) {
      var current = activeSlice[0].dataset.index;

      changeSlice(current, "down");

      if (window.scrollY > 0) {
        userHasScrolled = true
      }
      if (window.scrollY == 0 && userHasScrolled) {
        heroActive = true;
        fixScroll();
        userHasScrolled = false;
      }


    } else if (ts < te - 5) {
      var current = activeSlice[0].dataset.index;

      if (window.scrollY == 0) {
        changeSlice(current, "up");
      }

      if (window.scrollY == 0 && userHasScrolled) {
        heroActive = true;
        fixScroll();
        userHasScrolled = false;
      }
    }
  });
}